import Marquee from "react-fast-marquee";
import { useLang } from "../LanguageContext";

export const MarqueeStrip = () => {
  const { t } = useLang();
  return (
    <section className="bg-olive py-6 md:py-8 overflow-hidden" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-serif italic text-ivory text-3xl md:text-5xl px-8">{word}</span>
            <span className="text-gold text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
